module.exports = __webpack_public_path__ + "img/arvas.65a41aaf.png";